export default [
  {
    path: '/payment-history',
    name: 'PaymentHistory',
    component: () => import('@/views/PaymentHistory/Index.vue'),
    meta: {
      pageTitle: 'Ödeme Geçmişi',
      breadcrumb: [
        {
          text: 'Ödeme Geçmişi',
          active: true,
        },
      ],
      resource: 'PAYMENT_HISTORY_LIST',
      action: 'read',
    },
  },
  {
    path: '/payment-history/view/:id',
    name: 'PaymentHistoryView',
    component: () => import('@/views/PaymentHistory/View.vue'),
    meta: {
      pageTitle: 'Ödeme Geçmişi',
      breadcrumb: [
        {
          text: 'Ödeme Geçmişi',
          to: '/payment-history',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'PAYMENT_HISTORY_VIEW',
      action: 'read',
    },
  },
]
